import { DevicesSettingsService } from './devices-settings.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DevicesSettingsComponent } from './devices-settings.component';
import { SharedModule } from '../../../shared/shared.module';
import { RadioButtonModule } from 'primeng/radiobutton';

@NgModule({
  declarations: [DevicesSettingsComponent],
  imports: [CommonModule, SharedModule, RadioButtonModule],
  providers: [DevicesSettingsService],
})
export class DevicesSettingsModule {}
